import { css, type Theme } from "@emotion/react";

import { SafariOnlySelector } from "@shared/utils/SafariOnlySelector/SafariOnlySelector";

export const meter = {
  base: (theme: Theme) => css`
    -moz-appearance: none;
    border-radius: 4px;
    height: 0.5rem;
    background: ${theme.primary.backgroundMuted};

    /* needed for safari */
    border: 0;

    &&::-webkit-meter-bar {
      background: ${theme.primary.backgroundMuted};
      border-radius: 4px;
      border: none;
      height: 0.5rem;
    }

    &&::-webkit-meter-optimum-value {
      background: ${theme.primary.backgroundBase};
      border-radius: 4px;
    }

    // firefox
    &&::-moz-meter-bar {
      background: ${theme.primary.backgroundBase};
      border-radius: 4px;
    }

    ${SafariOnlySelector(css`
      -webkit-appearance: none;
      appearance: none;
    `)};
  `,

  filled: (theme: Theme) => css`
    &&::-webkit-meter-optimum-value {
      background: ${theme.success.backgroundBase};
    }

    // firefox
    &&::-moz-meter-bar {
      background: ${theme.success.backgroundBase};
    }
  `,
};
